import { useState } from "react";

/**
 * Hook customizado responsável por gerenciar o estado e a lógica de filtragem
 * de exercícios com base no tipo selecionado.
 *
 * Permite filtrar exercícios de diferentes categorias (como máquinas e gramáticas),
 * considerando os atributos `automatonType` e `grammarType` de cada item.
 *
 * Caso o tipo selecionado seja "all", nenhum filtro é aplicado e todos os exercícios
 * são retornados.
 *
 * @author Willian Brandao
 *
 * @param {Array<Object>} exercises Lista original de exercícios a ser filtrada.
 * @param {string} exercises[].automatonType Tipo do autômato (quando aplicável).
 * @param {string} exercises[].grammarType Tipo da gramática (quando aplicável).
 *
 * @returns {Object} Objeto contendo:
 * @returns {string} returns.selectedType Tipo atualmente selecionado para filtro.
 * @returns {Function} returns.setSelectedType Função para atualizar o tipo selecionado.
 * @returns {Array<Object>} returns.filteredExercises Lista de exercícios filtrada.
 *
 * @example
 * const {
 *   selectedType,
 *   setSelectedType,
 *   filteredExercises
 * } = useExerciseFilter(exercises);
 *
 * setSelectedType("AF");
 */
export function useExerciseFilter(exercises) {
  const [selectedType, setSelectedType] = useState("all");

  /**
   * Filtra a lista baseada no tipo selecionado.
   * Retorna todos os itens caso o filtro seja "all".
   */
  const filteredExercises = exercises.filter((ex) => {
    if (selectedType === "all") {
      return true;
    }
    let isMatch = false;
    if (ex.automatonType) {
      if (ex.automatonType === selectedType) {
        isMatch = true;
      }
    }
    if (ex.grammarType) {
      if (ex.grammarType === selectedType) {
        isMatch = true;
      }
    }
    return isMatch;
  });

  return {
    selectedType,
    setSelectedType,
    filteredExercises,
  };
}
